/**
 * Suppress Shopify Forms "Get 10% Off" overlay when it blocks shopping:
 * - never on product pages
 * - never while search is open / search input focused
 * - delay first show on other pages so shoppers can orient first
 */
(function () {
  var CLASS = "bowshock-forms-suppressed";
  var STYLE_ID = "bowshock-forms-guard-style";
  var DELAY_MS = 25000;
  var allowAfter = Date.now() + DELAY_MS;

  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent =
      "html." +
      CLASS +
      " shopify-forms-embed{display:none!important;visibility:hidden!important;pointer-events:none!important;opacity:0!important}";
    document.head.appendChild(style);
  }

  function isProductPage() {
    var main = document.getElementById("MainContent");
    if (main && main.getAttribute("data-template") === "product") return true;
    return /\/products\//.test(window.location.pathname);
  }

  function isSearchOpen() {
    if (document.querySelector("details-modal.header__search details[open], .header__search details[open]")) {
      return true;
    }
    if (document.querySelector('predictive-search[open], .search-modal:not([aria-hidden="true"])')) {
      return true;
    }
    var active = document.activeElement;
    if (
      active &&
      active.matches &&
      active.matches('input[type="search"], input[name="q"]') &&
      active.closest("header, .search-modal, predictive-search, details-modal")
    ) {
      return true;
    }
    return false;
  }

  function sync() {
    ensureStyle();
    var hide = isProductPage() || isSearchOpen() || Date.now() < allowAfter;
    document.documentElement.classList.toggle(CLASS, hide);
  }

  document.addEventListener("DOMContentLoaded", sync);
  document.addEventListener("focusin", sync);
  document.addEventListener("focusout", function () {
    setTimeout(sync, 0);
  });
  document.addEventListener("toggle", sync, true);
  document.addEventListener("click", function () {
    setTimeout(sync, 0);
  });
  document.addEventListener("keyup", function (event) {
    if (event.key === "Escape" || event.key === "/" || event.key === "f") {
      setTimeout(sync, 0);
    }
  });

  if (document.documentElement) {
    new MutationObserver(sync).observe(document.documentElement, {
      subtree: true,
      attributes: true,
      attributeFilter: ["open", "aria-hidden", "class"],
    });
  }

  sync();
  setTimeout(sync, DELAY_MS);
  if (isProductPage()) {
    setInterval(sync, 1500);
  }
})();
